import React from 'react';
import useCarousel from '../../Common/useCarousel';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { getAmenitiesIconUrl } from '../../CommonResp/utils'

const Amenities = (props) => {
    const { content, count } = props;
    const {
        dataList,
        increment,
        decrement,
        isLeftCursorActive,
        isRightCursorActive,
        leftCursor,
        rightCursor,
    } = useCarousel(content, count ? count : 2);
    return (<div className="makeFlex relative appendTop16">
        <div className="seoCarousel">
            <div className="sliderScrollAmenities">

                {dataList.map((obj, index) => {
                    if (obj && obj !== "NA") {
                        const url = getAmenitiesIconUrl(obj);
                        return (
                            <div key={obj + index} className="amenitiesList">
                                <span className="height30">
                                    <img data-src={url} className="lazyload" style={{ width: "16px", height: "16px" }} alt="amenities" />
                                </span>
                                <p className="amenitiesListItem">{obj}</p>
                            </div>
                        )
                    }
                })}
            </div>
            <div className="sliderNav sliderNavOperators">
                {isLeftCursorActive ? <p className="prev" onClick={() => {
                    decrement();
                }}>
                    <button>.</button>
                </p> : null}
                {isRightCursorActive ? <p className="next" onClick={() => {
                    increment();
                }}>
                    <button>.</button>
                </p> : null}
            </div>
        </div>
    </div>)
}

export default Amenities;
